module.exports = __webpack_public_path__ + "img/shiguan.546b5918.svg";